import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["shown", "used"]

  show() {
    this.element.classList.add(this.usedClass)
    this.element.classList.toggle(this.shownClass)
  }
}
